<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2>{{evaluateLanguageString(warningObg.title)}}</h2>
    <div>
      <ng-container *ngIf="!emphasizedText; then normalText else  emphasizedTextTemplate"></ng-container>
      <ng-template #normalText>
        <div class="warning_content">{{evaluateLanguageString(warningObg.content)}}</div>
      </ng-template>
      <ng-template #emphasizedTextTemplate>
        <div class="warning_content" [innerHTML]="warningObg.content">
        </div>
      </ng-template>
    </div>
    <div class="ya-button-container">
      <button mat-flat-button (click)="closeBottomSheet()">{{evaluateLanguageString(warningObg.btnLabel)}}</button>
    </div>
    <ng-container *ngIf="warningObg.option">
      <div class="warning-container">
        <div class="warning_content">{{evaluateLanguageString(warningObg.option)}}</div>
      </div>
    </ng-container>
  </div>
</div>